<!--
  - Copyright (c) 2020, Matthew T. Kaufman
  -->

<style>
    .dstyle  {
        border: unset !important;
       }

    .cstyle {
        border-bottom-color: red !important;
    }
</style>

<template>
    <v-container v-if="!isMobile">
        <v-data-table
                :headers="decodeHeaders"
                :items="decodeList"
                :custom-filter="decodeFilter"
                disable-pagination
                disable-sort
                hide-default-footer
                dense
                :loading="decodeLoading"
                class="elevation-1"
        >
            <template v-slot:item="row">
                <tr>
                    <td :class="listItemClass(row.index)">{{ row.item.decode.time | timeTranslate }}</td>
                    <td :class="listItemClass(row.index)">{{ row.item.decode.fmt }}</td>
                    <td :class="listItemClass(row.index)">{{ row.item.decode.from }}</td>
                    <td :class="listItemClass(row.index)">{{ row.item.decode.fromTranslation }}</td>
                    <td :class="listItemClass(row.index)">{{ row.item.decode.to }}</td>
                    <td :class="listItemClass(row.index)">{{ row.item.decode.toTranslation }}</td>
                    <td :class="listItemClass(row.index)">
                        <v-btn
                                icon
                                @click="onPlayback(row.item.decode.channel, row.item.decode.time)"
                        >
                            <v-icon>mdi-play-circle-outline</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>

        </v-data-table>
    </v-container>
    <v-container v-else>
        <v-data-iterator
                :items="decodeList"
                :custom-filter="decodeFilter"
                disable-pagination
                disable-sort
                hide-default-footer
                dense
                :loading="decodeLoading"
                class="elevation-0"
        >
            <template v-slot:item="row">
                <v-row>
                    <v-card
                            width="100%" tile class="elevation-1" ripple
                            @click="onPlayback(row.item.decode.channel, row.item.decode.time)"
                    >
                        <v-row no-gutters>
                            <v-col v-if="bestTitleBold(row)" class="h3">
                                {{bestTitle(row)}}
                            </v-col>
                            <v-col v-else class="h3 grey--text">
                                {{bestTitle(row)}}
                            </v-col>
                            <v-col class="text-right caption blue--text">
                                {{row.item.decode.time | mobileTimeTranslate}}
                            </v-col>
                        </v-row>
                    </v-card>
                </v-row>
                <v-divider v-if="listItemNeedsSeparatorAfter(row.item.idx)"></v-divider>
            </template>
        </v-data-iterator>
    </v-container>
</template>

<script>
    import moment from 'moment'
    import EventBus from '../event-bus'

    export default {
      props: {
            source: String
        },
        mounted() {
            EventBus.$on('reload',  () => {
                console.log("got reload event " + this.$route.params.channel)
                this.loadData();
            });
        },
        created() {
            console.log("DCR");
            this.loadData();
        },
        watch: {
            $route() {
                console.log("DW");
                this.loadData();
            }
        },
        methods: {
            listItemClass: function (index) {
              return this.listItemNeedsSeparatorAfter(index) ? "cstyle" : "dstyle";

            },
            listItemNeedsSeparatorAfter: function (index) {
                if(index < this.decodeList.length-1) {
                    var thisOne = this.decodeList[index].decode.time;
                    var nextOne = this.decodeList[index + 1].decode.time;
                  return thisOne > nextOne + 30;
                }
                return false
            },
            loadData() {
                this.onChannelChange(this.$route.params.channel)
            },
            onChannelChange(channel)  {
                console.log("OCC " + channel )
                this.decodeLoading = true;
                var after;
                var before;
                var dateValue = this.$store.getters.date
                console.log("retrieved date value "+dateValue)
                if (dateValue.length === 10) {
                    after = moment(dateValue)
                    before = after.clone().add(1, 'days').subtract(1, 'second')
                } else {
                    var today = moment().format('YYYY-MM-DD')
                    after = moment(today).subtract(2, 'days')
                    before = moment(today).add(1, 'days').subtract(1, 'second')
                }
                // console.log("after "+after.toISOString()+" before "+before.toISOString())
                this.$axios
                    .get("/decodeindex/" + channel + "?after=" + after.unix() + "&before=" + before.unix())
                    .then(response => {
                        this.decodeList = response.data;
                        this.decodeLoading = false;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            onPlayback(channel, time) {
              this.$emit("playback", channel, time);
            },
            bestTitle(row)
            {
                if(row.item.decode.toTranslation)
                    return row.item.decode.toTranslation
                else if(row.item.decode.to)
                    return row.item.decode.fmt + " " +row.item.decode.to
                else if(row.item.decode.from)
                    return row.item.decode.fmt + " "+row.item.decode.from
                else
                    return "?"
            },
            bestTitleBold(row)
            {
                if(row.item.decode.toTranslation)
                    return true;
                return false;
            },
            decodeFilter(items /*, search, filter*/)
            {
                // first filter
                // items.filter(item => ...
                // then add indexes for things that don't have them
                let i=0;
                items.forEach(item => {
                    item.idx = i++
            })
                return items
            }
        },
        filters: {
            timeTranslate(val) {
                return moment.unix(val).format('ddd M/D/YYYY HH:mm:ss')
            },
            mobileTimeTranslate(val) {
                return moment.unix(val).format('HH:mm:ss M/D/YY')
            }
        },
        computed: {
            isMobile()
            {
                return (this.$vuetify.breakpoint.xsOnly)
            }
        },
        data: () => ({
            decodeLoading: null,
            decodeList: [],
            decodeHeaders: [
                {text: "When"},
                {text: "Format"},
                {text: "From"},
                {text: "Translation"},
                {text: "To"},
                {text: "Translation"},
                {text: "Action"}
            ]
        })
    };
</script>
